import * as NextSkyTheme from "@NextSkyTheme/global";
import { eventModal } from "@NextSkyTheme/modal";

if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        this.abortController = null;
        this.previewButtonTimer = null;
        this.onClickPreviewButton = this.onClickPreviewButton.bind(this);
        if (!this.hasAttribute("available")) return;
        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(variantSectionUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            if (!this.isConnected) return;
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            if (e.name === "AbortError") return;
            if (!this.isConnected) return;
            const button = this.querySelector("button");
            if (button)
              button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      onClickPreviewButton() {
        document.querySelector("pickup-availability-drawer")?.show();
        NextSkyTheme.global.rootToFocus = this.previewButton;
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);
        this.querySelector("button").addEventListener(
          "click",
          this.onClickRefreshList
        );
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector(".pickup-availability-drawer");
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector(".pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }
        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview"
        ).outerHTML;
        this.setAttribute("available", "");
        document.body.appendChild(
          sectionInnerHTML.querySelector(".pickup-availability-drawer")
        );
        if (this.previewButton) {
          this.previewButton.removeEventListener("click", this.onClickPreviewButton);
        }
        this.previewButton = this.querySelector("button");
        clearTimeout(this.previewButtonTimer);
        this.previewButtonTimer = setTimeout(() => {
          if (this.previewButton && this.isConnected) {
            this.previewButton.addEventListener("click", this.onClickPreviewButton);
          }
        }, 800);
      }

      disconnectedCallback() {
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
        clearTimeout(this.previewButtonTimer);
        this.previewButtonTimer = null;
        if (this.previewButton) {
          this.previewButton.removeEventListener("click", this.onClickPreviewButton);
          this.previewButton = null;
        }
      }
    }
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();
      }

      show() {
        eventModal(this, "open");
      }
    }
  );
}
